export default __webpack_public_path__ + "static/Cost-Optimization-061447194a642b29c9b9d4b3afc88e21.webp";